







































import Vue, {VueConstructor} from 'vue'
import {TableTreeOptions, TableTreeProps} from './core/TableTree'
import {ActionsDwopdownOptions} from '@/components/Ui/ActionsDropdown/core/ActionsDropdown'
import UiTree from '@/components/Ui/Tree/Tree.vue'
export default (Vue as VueConstructor<Vue & {
  lazy: (node: any, resolve: (nodes: any[]) => any) => Promise<any>
}>).extend({
  name: 'UiTableTree',
  components: {UiTree},
  props: {
    data: {
      type: Array as () => any[],
      default: () => []
    },
    cols: {
      type: Object as () => TableTreeOptions,
      default () {
        return {}
      }
    },
    treeProps: {
      type: Object as () => TableTreeProps,
      default () {
        return {}
      }
    },
    nodeIndent: {
      type: Number,
      default: 36
    },
    gridTemplateColumns: {
      type: String,
      default: '1fr'
    },
    scope: {},
    lazy: Function,
    defaultExpandedKeys: {
      type: Array as () => string[],
      default: () => []
    }
  },
  methods: {
    async loadMethod (node: any, resolve: (nodes: any[]) => any) {
      let data: any[] = await this.lazy(node, resolve)
      return data;
    },
    onNodeClick (event: any) {
      this.$emit('node-click', event)
    },
    onNodeExpand (event: any) {
      this.$emit('node-expand', event)
    },
    onNodeCollapse (event: any) {
      this.$emit('node-collapse', event)
    }
  },
  computed: {
  }
})
